<template>
    <font-awesome-icon class="fa-fw" :icon="['fal', 'chevron-down']" />
</template>

<script>
    export default {
        name: "OpenIndicator"
    }
</script>

<style lang="scss" scoped>
    .fa-fw {
        path {
            fill: #4d4d4d;
        }
    }
</style>